// Every editable string on the public site, holding today's exact wording as the
// fallback. The Control Room only stores overrides, so an empty field reads from here.
export const DEFAULT_TEXT = {
    home_word_1: "Aye",
    home_word_2: "Vibe",
    home_word_3: "Muzik",
    home_tagline:
        "Kingdom Sound. Urban Energy. Music built where the street meets the sanctuary — every bar a testimony, every hook a hallelujah.",
    banner_1: "Kingdom Sound",
    banner_2: "Urban Energy",
    banner_3: "Faith In Every Frequency",
    banner_4: "Unshaken",
    footer_tagline: "Kingdom Sound. Urban Energy. Faith in every frequency.",
    about_label: "The Mission",
    about_headline: "Music for the Kingdom",
    about_subline: "Faith-Based Urban Artist",
    about_quote: "The message was never about the messenger.",
    about_body_1: "ayevibemuzik makes music that points to the King, not the artist.",
    about_body_2:
        "Every project is built on the Word — from Bere'shiyth, the beginning, to Halak, the daily walk, to Dabar, the Word itself.",
    about_body_3:
        "The goal is simple: carry scripture into everyday life and meet people right where they are.",
    about_body_4: "Press play and let the Word do the work.",
    about_card_1_title: "Scripture First",
    about_card_1_text: "Every track is built on the Word of Yahuah. Not borrowed slogans. Scripture.",
    about_card_2_title: "Hebrew Roots",
    about_card_2_text:
        "Album titles and the names of the Father come from the Hebrew Scriptures: Elohim, El Shaddai, Yahuah.",
    about_card_3_title: "Real Life",
    about_card_3_text: "DMs, group chats, temptation, false friends. Everyday life, seen through the Word.",
    about_card_4_title: "Built to Last",
    about_card_4_text: "A catalog made to outlast the moment and speak to the next generation.",
    about_vision:
        "One album at a time, the whole story of Scripture — from Bere'shiyth toward Revelation.",
};

export const TEXT_GROUPS = [
    {
        title: "Home",
        fields: [
            { key: "home_word_1", label: "Headline word 1" },
            { key: "home_word_2", label: "Headline word 2 (gold)" },
            { key: "home_word_3", label: "Headline word 3" },
            { key: "home_tagline", label: "Hero tagline", long: true },
        ],
    },
    {
        title: "Scrolling banner",
        fields: [
            { key: "banner_1", label: "Phrase 1" },
            { key: "banner_2", label: "Phrase 2" },
            { key: "banner_3", label: "Phrase 3" },
            { key: "banner_4", label: "Phrase 4" },
        ],
    },
    { title: "Footer", fields: [{ key: "footer_tagline", label: "Footer tagline", long: true }] },
    {
        title: "About — mission",
        fields: [
            { key: "about_label", label: "Label" },
            { key: "about_headline", label: "Headline" },
            { key: "about_subline", label: "Small line" },
            { key: "about_quote", label: "Pull quote", long: true },
            { key: "about_body_1", label: "Body line 1", long: true },
            { key: "about_body_2", label: "Body line 2", long: true },
            { key: "about_body_3", label: "Body line 3", long: true },
            { key: "about_body_4", label: "Body line 4", long: true },
        ],
    },
    {
        title: "About — what the music carries",
        fields: [
            { key: "about_card_1_title", label: "Card 1 title" },
            { key: "about_card_1_text", label: "Card 1 text", long: true },
            { key: "about_card_2_title", label: "Card 2 title" },
            { key: "about_card_2_text", label: "Card 2 text", long: true },
            { key: "about_card_3_title", label: "Card 3 title" },
            { key: "about_card_3_text", label: "Card 3 text", long: true },
            { key: "about_card_4_title", label: "Card 4 title" },
            { key: "about_card_4_text", label: "Card 4 text", long: true },
        ],
    },
    { title: "About — the vision", fields: [{ key: "about_vision", label: "Vision line", long: true }] },
];

export const SOCIAL_PLATFORMS = [
    { value: "instagram", label: "Instagram" },
    { value: "tiktok", label: "TikTok" },
    { value: "youtube", label: "YouTube" },
    { value: "spotify", label: "Spotify" },
    { value: "apple", label: "Apple Music" },
    { value: "amazon", label: "Amazon Music" },
    { value: "audiomack", label: "Audiomack" },
    { value: "facebook", label: "Facebook" },
    { value: "x", label: "X" },
    { value: "other", label: "Other" },
];
